<template>
  <div>    
    <modal
      v-model:show="errors.length"
      modal-classes="modal-danger"
      modal-content-classes="bg-gradient-danger"
    >
      <template v-slot:header>
        <h6 class="modal-title">{{$t($route.name+'.errorsModalTitle')}}</h6>
      </template>

      <div class="py-3 text-center">
        <i class="ni ni-support-16 ni-3x"></i>
        <h4 class="heading mt-4">{{$t($route.name+'.errorsModalBodyTitle')}}</h4>
        <ul v-for="error in errors" :key="error">
          <li>{{error}}</li>
        </ul>
      </div>

      <template v-slot:footer>
        <base-button
          type="link"
          class="text-white ml-auto"
          v-on:click="errors = []"
          >{{$t($route.name+'.errorsModalCloseButton')}}</base-button
        >
      </template>
    </modal>

    <base-header
      class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center"
      style="
        background-size: cover;
        background-position: center top;
      "
    >
      <!-- Mask -->
      <span class="mask bg-gradient-success opacity-8"></span>
      <!-- Header container -->
      
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col-xl-4 order-xl-2 mb-5 mb-xl-0">
          <div class="card card-profile shadow">
            <div class="row justify-content-center">
              <div class="col-lg-3 order-lg-2">
                <div class="card-profile-image">
                  <a href="#">
                    <img
                      src="static/img/brand/name_only.png"
                      class="rounded-circle.$model"
                    />
                  </a>
                </div>
              </div>
            </div>
            <div
              class="card-header text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4"
            >
            </div>
            <div class="card-body pt-0 pt-md-4">
              <div class="row">
                <div class="col">
                  <div
                    class="card-profile-stats d-flex justify-content-center mt-md-5"
                  >
                    <div>
                      <span class="heading">{{num_terrains}}</span>
                      <span class="description">{{$t($route.name+'.terrains')}}</span>
                    </div>
                    <div>
                      <span class="heading">{{num_modules}}</span>
                      <span class="description">{{$t($route.name+'.modules')}}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="text-center">
                <h3>
                  {{original_model.name}} {{original_model.lastName1}}
                </h3>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-8 order-xl-1">
          <card shadow type="seconday">
            <template v-slot:header>
              <div class="bg-white border-0">
                <div class="row align-items-center">
                  <div class="col-8">
                    <h3 class="mb-0">{{$t($route.name+'.myDataTitle')}}</h3>
                  </div>
                </div>
              </div>
            </template>

              <h6 class="heading-small text-muted mb-4">{{$t($route.name+'.aboutMeTitle')}}</h6>
              <div class="pl-lg-4">
                <div class="row">
                  <div class="col-lg-6">
                    <base-input
                      alternative=""
                      :label="$t($route.name+'.usernameLabel')"
                      disabled
                      input-classes="form-control-alternative"
                      v-model="model.username"
                    />
                  </div>
                  <div class="col-lg-6">
                    <base-input
                      alternative=""
                      :label="$t($route.name+'.nifLabel')"
                      :placeholder="$t($route.name+'.nifPlaceholder')"
                      input-classes="form-control-alternative"
                      :error="errorsArrayToSingleString(v$.model.nif.$errors)"
                      v-model="v$.model.nif.$model"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <base-input
                      alternative=""
                      :label="$t($route.name+'.emailLabel')"
                      :placeholder="$t($route.name+'.emailPlaceholder')"
                      disabled
                      input-classes="form-control-alternative"
                      :error="errorsArrayToSingleString(v$.model.email.$errors)"
                      v-model="v$.model.email.$model"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-6">
                    <base-input
                      alternative=""
                      :label="$t($route.name+'.nameLabel')"
                      :placeholder="$t($route.name+'.namePlaceholder')"
                      input-classes="form-control-alternative"
                      :error="errorsArrayToSingleString(v$.model.name.$errors)"
                      v-model="v$.model.name.$model"
                    />
                  </div>
                  <div class="col-lg-6">
                    <base-input
                      alternative=""
                      :label="$t($route.name+'.lastName1Label')"
                      :placeholder="$t($route.name+'.lastName1Placeholder')"
                      input-classes="form-control-alternative"
                      :error="errorsArrayToSingleString(v$.model.lastName1.$errors)"
                      v-model="v$.model.lastName1.$model"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-6">
                    <base-input
                      alternative=""
                      :label="$t($route.name+'.lastName2Label')"
                      :placeholder="$t($route.name+'.lastName2Placeholder')"
                      input-classes="form-control-alternative"
                      :error="errorsArrayToSingleString(v$.model.lastName2.$errors)"
                      v-model="v$.model.lastName2.$model"
                    />
                  </div>
                  <div class="col-lg-6">
                    <base-input
                      alternative=""
                      :label="$t($route.name+'.phoneLabel')"
                      :placeholder="$t($route.name+'.phonePlaceholder')"
                      input-classes="form-control-alternative"
                      :error="errorsArrayToSingleString(v$.model.phone.$errors)"
                      v-model="v$.model.phone.$model"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-6">
                    <span>{{$t($route.name+'.selectLanguage')}}:</span>
                  </div>
                  <div class="col-lg-6">
                    <div class="row">
                      <a type="button" v-for="entry in languages" :key="entry.title" v-on:click="changeLocale(entry.language)">
                        <div class="col" v-if="entry.language == model.language">
                          <flag class="selected-locale flag-custom" :iso="entry.flag" v-bind:squared=false /> {{entry.title}}
                        </div>
                        <div class="col" v-else>
                          <flag class="flag-custom" :iso="entry.flag" v-bind:squared=false /> {{entry.title}}
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <hr class="my-4" />
              <!-- Address -->
              <h6 class="heading-small text-muted mb-4">{{$t($route.name+'.contactInfoTitle')}}</h6>
              <div class="pl-lg-4">
                <div class="row">
                  <div class="col"></div>
                  
                  <div class="col-lg-auto">
                    <span><small>{{$t($route.name+'.addressSearchBarLabel')}}:</small></span>
                    <GMapAutocomplete 
                    class="input-group"
                    :placeholder="$t($route.name+'.accountGoogleAskAddressPlaceholder')"
                    @place_changed="setPlace"
                    :options="{ types: ['address']}"
                  />
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <base-input
                      alternative=""
                      :label="$t($route.name+'.addressLabel')"
                      :placeholder="$t($route.name+'.addressPlaceholder')"
                      input-classes="form-control-alternative"
                      :error="errorsArrayToSingleString(v$.model.address.$errors)"
                      v-model="v$.model.address.$model"
                    />
                  </div>
                  <div class="col-sm-3">
                    <base-input
                      alternative=""
                      type="number"
                      min=0
                      :label="$t($route.name+'.numberLabel')"
                      :placeholder="$t($route.name+'.numberPlaceholder')"
                      input-classes="form-control-alternative"
                      v-model="model.number"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-4">
                    <base-input
                      alternative=""
                      :label="$t($route.name+'.cityLabel')"
                      :placeholder="$t($route.name+'.cityPlaceholder')"
                      input-classes="form-control-alternative"
                      :error="errorsArrayToSingleString(v$.model.city.$errors)"
                      v-model="v$.model.city.$model"
                    />
                  </div>
                  <div class="col-lg-4">
                    <base-input
                      alternative=""
                      :label="$t($route.name+'.provinceLabel')"
                      :placeholder="$t($route.name+'.provincePlaceholder')"
                      input-classes="form-control-alternative"
                      :error="errorsArrayToSingleString(v$.model.province.$errors)"
                      v-model="v$.model.province.$model"
                    />
                  </div>
                  <div class="col-lg-4">
                    <base-input
                      alternative=""
                      type="number"
                      min=0
                      :label="$t($route.name+'.zipLabel')"
                      :placeholder="$t($route.name+'.zipPlaceholder')"
                      input-classes="form-control-alternative"
                      :error="errorsArrayToSingleString(v$.model.zipCode.$errors)"
                      v-model="v$.model.zipCode.$model"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-6">
                    <base-input
                      alternative=""
                      :label="$t($route.name+'.regionLabel')"
                      :placeholder="$t($route.name+'.regionPlaceholder')"
                      input-classes="form-control-alternative"
                      :error="errorsArrayToSingleString(v$.model.region.$errors)"
                      v-model="v$.model.region.$model"
                    />
                  </div>
                  <div class="col-lg-6">
                    <base-input
                      alternative=""
                      :label="$t($route.name+'.countryLabel')"
                      :placeholder="$t($route.name+'.countryPlaceholder')"
                      input-classes="form-control-alternative"
                      :error="errorsArrayToSingleString(v$.model.country.$errors)"
                      v-model="v$.model.country.$model"
                    />
                  </div>
                </div>
              </div>
              <hr class="my-4" />
              <!-- Description -->
              <div class="row">
                <div class="col">
                </div>
                <div class="col-auto">
                  <base-button
                    type="success"
                    v-on:click="onUpdate()"
                  >
                    {{$t($route.name+'.updateButton')}}
                  </base-button>
                  <base-button
                    outline
                    v-on:click="onRestore()"
                  >
                    {{$t($route.name+'.restoreButton')}}
                  </base-button>
                </div>
              </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LandlordService from '@/services/landlord.service'

import i18n from '@/contents/contents'

import useVuelidate from '@vuelidate/core'
import { required, minLength, email, numeric, helpers } from '@vuelidate/validators'

export function validName(name) {
  let validNamePattern = new RegExp("^[a-zA-ZÀ-ÿ]+(?:[-'\\s][a-zA-Z]+)*$");
  if (validNamePattern.test(name)){
    return true;
  }
  return false;
}

export function validNif(nif) {
  let validNamePattern = new RegExp("([a-z]|[A-Z]|[0-9])[0-9]{7}([a-z]|[A-Z]|[0-9])");
  if (validNamePattern.test(nif)){
    return true;
  }
  return false;
}

export default {
  name: "user-account",
  setup(){
    return { v$: useVuelidate() }
  },
  data() {
    return {
      model: {
        username: null,
        email: null,
        name: null,
        lastName1: null,
        lastName2: null,
        phone: null,
        nif: null,        
        address: null,
        number: null,
        city: null,
        province: null,
        region: null,
        country: null,
        zipCode: null,
      },
      original_model: null,
      num_terrains: 0,
      num_modules: 0,
      errors : [],
      languages: [
          { flag: 'us', language: 'en' },
          { flag: 'es', language: 'es' },
          { flag: 'es-ct', language: 'cat'}
      ]
    };
  },
  validations() {
    return {
      model: {
        email: {
          required_custom: helpers.withMessage(this.$t(this.$route.name+'.errorFieldRequired'), required),
          email: helpers.withMessage(this.$t(this.$route.name+'.errorFieldEmail'), email),
        },
        name: {
          required_custom: helpers.withMessage(this.$t(this.$route.name+'.errorFieldRequired'), required),
          textField_validation: helpers.withMessage(this.$t(this.$route.name+'.errorInvalidField'), validName), 
        },
        lastName1: {
          required_custom: helpers.withMessage(this.$t(this.$route.name+'.errorFieldRequired'), required),
          textField_validation: helpers.withMessage(this.$t(this.$route.name+'.errorInvalidField'), validName), 
        },
        lastName2: {
          textField_validation: helpers.withMessage(this.$t(this.$route.name+'.errorInvalidField'), validName), 
        },
        phone: {
          required_custom: helpers.withMessage(this.$t(this.$route.name+'.errorFieldRequired'), required),
          numeric: helpers.withMessage(this.$t(this.$route.name+'.errorFieldNumeric'), numeric),
          min: helpers.withMessage(this.$t(this.$route.name+'.errorInvalidLength', {length: 9}), minLength(9)),
        },
        nif: {
          required_custom: helpers.withMessage(this.$t(this.$route.name+'.errorFieldRequired'), required),
          textField_validation: helpers.withMessage(this.$t(this.$route.name+'.errorInvalidNif'), validNif),
        },
        address: {
          required_custom: helpers.withMessage(this.$t(this.$route.name+'.errorFieldRequired'), required),
          textField_validation: helpers.withMessage(this.$t(this.$route.name+'.errorInvalidField'), validName), 
        },
        city: {
          required_custom: helpers.withMessage(this.$t(this.$route.name+'.errorFieldRequired'), required),
          textField_validation: helpers.withMessage(this.$t(this.$route.name+'.errorInvalidField'), validName), 
        },
        province: {
          required_custom: helpers.withMessage(this.$t(this.$route.name+'.errorFieldRequired'), required),
          textField_validation: helpers.withMessage(this.$t(this.$route.name+'.errorInvalidField'), validName), 
        },
        region: {
          required_custom: helpers.withMessage(this.$t(this.$route.name+'.errorFieldRequired'), required),
          textField_validation: helpers.withMessage(this.$t(this.$route.name+'.errorInvalidField'), validName), 
        },
        country: {
          required_custom: helpers.withMessage(this.$t(this.$route.name+'.errorFieldRequired'), required),
          textField_validation: helpers.withMessage(this.$t(this.$route.name+'.errorInvalidField'), validName), 
        },
        zipCode: {
          required_custom: helpers.withMessage(this.$t(this.$route.name+'.errorFieldRequired'), required),
          min: helpers.withMessage(this.$t(this.$route.name+'.errorInvalidLength', {length: '5'}), minLength(5)),
        },
      },
    }
  },
  created(){
    
    this.onCreated();

  },
  methods: {
    setPlace(place){      
      this.model.address = place.address_components[0].long_name;
      this.model.city = place.address_components[1].long_name;
      this.model.province = place.address_components[2].long_name;
      this.model.region = place.address_components[3].long_name;
      this.model.country = place.address_components[4].long_name;
      if(place.address_components.length == 6){
        this.model.zipCode = place.address_components[5].long_name;
      }
    },
    onCreated(){
      var landlord = JSON.parse(localStorage.getItem("landlord"));
      var user = JSON.parse(localStorage.getItem("user")).user;

      i18n.global.locale = landlord.contact_details.language;

      const get_model = {
        username  : user.name,
        email     : user.email,
        language  : landlord.contact_details.language,
        name      : landlord.contact_details.name.first_name,
        lastName1 : landlord.contact_details.name.surname_1,
        lastName2 : landlord.contact_details.name.surname_2,
        phone     : landlord.contact_details.phone[0],
        nif       : landlord.contact_details.personal_id,
        address   : landlord.contact_details.address.street,
        number    : landlord.contact_details.address.number,
        city      : landlord.contact_details.address.municipality,
        province  : landlord.contact_details.address.province,
        region    : landlord.contact_details.address.region,
        country   : landlord.contact_details.address.country,
        zipCode   : landlord.contact_details.address.postal_code,
      }
      
      this.model = get_model;
      this.original_model = JSON.parse(JSON.stringify(this.model));

      this.num_terrains = landlord.terrains.length;
      this.num_modules = 0;
      landlord.terrains.forEach(terrain => {
        if (terrain.plots){
            terrain.plots.forEach(plot => {
            this.num_modules += plot.modules.length;
          })
        }
        
      })
      // console.log(landlord)
    },
    onUpdate(){
      this.v$.$touch();
      if(this.v$.model.$invalid){
        return;
      }

      // Update local data
      var landlord = JSON.parse(localStorage.getItem("landlord"));

      this.model.language = i18n.global.locale;

      landlord.contact_details.name.first_name = this.model.name;
      landlord.contact_details.name.surname_1 = this.model.lastName1;
      landlord.contact_details.name.surname_2 = this.model.lastName2;
      landlord.contact_details.phone[0] = this.model.phone;
      landlord.contact_details.personal_id = this.model.nif;
      landlord.contact_details.address.street = this.model.address;
      landlord.contact_details.address.number = this.model.number;
      landlord.contact_details.address.municipality = this.model.city;
      landlord.contact_details.address.province = this.model.province;
      landlord.contact_details.address.region = this.model.region;
      landlord.contact_details.address.country = this.model.country;
      landlord.contact_details.address.postal_code = this.model.zipCode;
      landlord.contact_details.language = this.model.language;

      LandlordService.updateLandlordById(landlord.id, landlord).then(
        response => {
          // update local user
          var landlord = JSON.parse(localStorage.getItem("landlord"));
          landlord = response;
          localStorage.setItem('landlord', JSON.stringify(landlord));

          // Reload the page to refresh data
          this.$router.go();
        },
        error => {
          this.errors.push(error);
        }
      );
    },

    onRestore(){
      this.model = JSON.parse(JSON.stringify(this.original_model));
    },

    errorsArrayToSingleString(array){
      var str = "";
      if(array.length == 0) return
      array.forEach(item => str += item.$message+'\n')
      return str;
    },

    changeLocale(locale) {
        i18n.global.locale = locale;
        this.model.language = locale;
    }
  },
};
</script>
<style>
.selected-locale {

  outline: 5px ridge rgba(26, 6, 1, 0.6) !important;
  border-radius: 2rem;
  
}

.flag-custom {
  
}

</style>
